import { CustomerDocumentSearchRequestQuery, CustomerDocumentSearchResponse } from '@lio/api-types';
import { customerQueryKey } from '@services/customer/keys';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

type CustomerDocumentSearchParams = CustomerDocumentSearchRequestQuery & { customerId?: string };

const buildQuery = (params: CustomerDocumentSearchRequestQuery) => {
  const query = new URLSearchParams();
  if (params.pageLimit) query.append('pageLimit', String(params.pageLimit));
  if (params.pageOffset) query.append('pageOffset', String(params.pageOffset));
  if (params.documentTypeId) {
    const ids = Array.isArray(params.documentTypeId) ? params.documentTypeId : [params.documentTypeId];
    ids.forEach((id) => {
      if (id) query.append('documentTypeId', id);
    });
  }
  query.append('sort', params.sort ?? '-createdAt,-updatedAt');
  return query.toString();
};

export const useSearchCustomerDocuments = ({ customerId, ...params }: CustomerDocumentSearchParams, enabled = true) => {
  const client = useClient();
  const query = buildQuery(params);

  const result = useQuery<CustomerDocumentSearchResponse, Error>({
    queryKey: customerQueryKey.searchCustomerDocuments(customerId, params),
    queryFn: () => client.get(`customer/${customerId}/document?${query}`).json<CustomerDocumentSearchResponse>(),
    enabled: !!customerId && enabled,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
  });

  return { ...result, documents: result.data };
};
